import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterDirecciones'
})
export class FilterDireccionesPipe implements PipeTransform {

  transform(value: any[], args?: string): any[] {
    if (!args || !value) return value;

    const filterValue = args.toLowerCase();

    return value.filter(dr => {
      return (
        (dr.sDesCorto03?.toLowerCase().includes(filterValue)) ||
        (dr.nNumero03?.toString().toLowerCase().includes(filterValue)) ||
        (dr.sDesCorto01?.toLowerCase().includes(filterValue)) ||
        (dr.sDesLargo02?.toLowerCase().includes(filterValue)) ||
        (dr.sDesLargo05?.toLowerCase().includes(filterValue))
      );
    });
  }
}
